<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待开票列表" name="electronicBlueWaitingList"></el-tab-pane>
      <el-tab-pane label="开票记录" name="electronicBlueRecordList"></el-tab-pane>
    </el-tabs>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'electronicBlueIndex',
  computed: {},
  data() {
    return {
      activeName: 'electronicBlueWaitingList',
      routerList: []
    }
  },
  created() { },
  mounted() {
    this.tabRoute(this.$route.name)
  },
  methods: {
    tabRoute(name) {
      this.activeName = name
    },
    handleClick(tab) {
      this.$router.push({ name: tab.name })
    }
  }
}
</script>